import config from '../config/default'

/**
 * Format a price according to currency locale
 */
export function formatPrice(amount: number, currencyCode: string, fixedDecimals?: number): string {
  const currency = config.currencies.find(c => c.value === currencyCode)
  const formatLocale = currency?.formatLocale || 'en-US'

  try {
    // If fixedDecimals is provided, use it for both min/max fraction digits
    // Otherwise, use the amount's decimals as-is
    const options: Intl.NumberFormatOptions = {
      style: 'currency',
      currency: currencyCode,
    }
    if (typeof fixedDecimals === 'number') {
      options.minimumFractionDigits = fixedDecimals
      options.maximumFractionDigits = fixedDecimals
    } else {
      const decimalPart = amount.toString().split('.')[1]
      const decimals = decimalPart ? decimalPart.length : 0
      options.minimumFractionDigits = 2
      options.maximumFractionDigits = Math.max(2, decimals)
    }
    return new Intl.NumberFormat(formatLocale, options).format(amount)
  } catch {
    // Fallback for unsupported currencies
    if (typeof fixedDecimals === 'number') {
      return `${currencyCode} ${amount.toFixed(fixedDecimals)}`
    }
    return `${currencyCode} ${amount}`
  }
}

/**
 * Get currency symbol for a currency code
 */
export function getCurrencySymbol(currencyCode: string): string {
  const currency = config.currencies.find(c => c.value === currencyCode)
  const formatLocale = currency?.formatLocale || 'en-US'

  try {
    return (
      new Intl.NumberFormat(formatLocale, {
        style: 'currency',
        currency: currencyCode,
      })
        .formatToParts(0)
        .find(part => part.type === 'currency')?.value || currencyCode
    )
  } catch {
    // Fallback for unsupported currencies
    return currencyCode
  }
}
